import React from "react";

const ShipmentsPage = () => {
  const shipments = [
    {
      id: 1,
      order: 4,
      pickup: true,
      tracking: "",
      weight: "4.00 [lb(s)]",
      dateShipped: "-",
      dateReady: "2/11/2025 10:34:47 PM",
      dateDelivered: "2/11/2025 10:34:47 PM",
    },
    {
      id: 2,
      order: 4,
      pickup: true,
      tracking: "",
      weight: "2.00 [lb(s)]",
      dateShipped: "-",
      dateReady: "2/11/2025 10:34:47 PM",
      dateDelivered: "2/11/2025 10:34:47 PM",
    },
    {
      id: 3,
      order: 5,
      pickup: false,
      tracking: "",
      weight: "2.00 [lb(s)]",
      dateShipped: "2/11/2025 10:34:47 PM",
      dateReady: "-",
      dateDelivered: "2/11/2025 10:34:47 PM",
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen p-6 md:p-10">
      {/* Header */}
      <div className="flex flex-wrap justify-between items-center mb-6">
        <h1 className="text-2xl md:text-3xl font-semibold">Shipments</h1>
        <div className="flex flex-wrap gap-3 mt-3 md:mt-0">
          <button className="bg-sky-500 hover:bg-sky-600 text-white px-4 py-2 rounded-lg shadow">
            🧾 Print packaging slips
          </button>
          <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow">
            🚚 Set as shipped (selected)
          </button>
          <button className="bg-sky-400 hover:bg-sky-500 text-white px-4 py-2 rounded-lg shadow">
            📦 Set as ready for pickup (selected)
          </button>
          <button className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg shadow">
            ✅ Set as delivered (selected)
          </button>
        </div>
      </div>

      {/* Search Section */}
      <div className="bg-white rounded-2xl shadow p-6 mb-8">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
          🔍 Search
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Start date</label>
            <input
              type="date"
              className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">End date</label>
            <input
              type="date"
              className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Tracking number
            </label>
            <input
              type="text"
              placeholder="Enter tracking number"
              className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Warehouse</label>
            <select className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300">
              <option>All</option>
              <option>Warehouse A</option>
              <option>Warehouse B</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Country</label>
            <select className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300">
              <option>Select country</option>
              <option>USA</option>
              <option>India</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              State / province
            </label>
            <input
              type="text"
              placeholder="Other"
              className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              County / region
            </label>
            <input
              type="text"
              className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">City</label>
            <input
              type="text"
              className="w-full border rounded-lg px-3 py-2 focus:ring focus:ring-blue-300"
            />
          </div>

          <div className="flex flex-col justify-center gap-1">
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" /> Load not shipped
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" /> Load not delivered
            </label>
            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" /> Load not ready for pickup
            </label>
          </div>
        </div>

        <div className="mt-6 flex justify-center">
          <button className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2">
            🔎 Search
          </button>
        </div>
      </div>

      {/* Shipments Table */}
      <div className="bg-white rounded-2xl shadow p-6">
        <h2 className="text-lg font-semibold mb-4">
          Learn more about{" "}
          <span className="text-blue-600 cursor-pointer">shipping management</span>
        </h2>

        {/* Desktop View */}
        <div className="hidden md:block overflow-x-auto">
          <table className="min-w-full text-sm border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 border">Shipment #</th>
                <th className="p-3 border">Order #</th>
                <th className="p-3 border">Pickup from store</th>
                <th className="p-3 border">Tracking number</th>
                <th className="p-3 border">Total weight</th>
                <th className="p-3 border">Date shipped</th>
                <th className="p-3 border">Date ready for pickup</th>
                <th className="p-3 border">Date delivered</th>
                <th className="p-3 border">View</th>
              </tr>
            </thead>
            <tbody>
              {shipments.map((s) => (
                <tr key={s.id} className="hover:bg-gray-50">
                  <td className="p-3 border text-center">{s.id}</td>
                  <td className="p-3 border text-center">{s.order}</td>
                  <td className="p-3 border text-center">
                    {s.pickup ? (
                      <span className="text-blue-600 text-lg">✔️</span>
                    ) : (
                      <span className="text-red-600 text-lg">❌</span>
                    )}
                  </td>
                  <td className="p-3 border text-center">{s.tracking}</td>
                  <td className="p-3 border text-center">{s.weight}</td>
                  <td className="p-3 border text-center">{s.dateShipped}</td>
                  <td className="p-3 border text-center">{s.dateReady}</td>
                  <td className="p-3 border text-center">{s.dateDelivered}</td>
                  <td className="p-3 border text-center">
                    <button className="px-3 py-1 bg-gray-100 hover:bg-gray-200 rounded-md">
                      👁 View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile View */}
        <div className="md:hidden grid gap-4">
          {shipments.map((s) => (
            <div
              key={s.id}
              className="border rounded-xl p-4 bg-gray-50 shadow-sm space-y-2"
            >
              <div className="flex justify-between items-center">
                <span className="font-semibold text-base">
                  Shipment #{s.id}
                </span>
                <span className="text-sm font-medium text-gray-600">
                  Order #{s.order}
                </span>
              </div>
              <p className="text-sm">
                Pickup from store:{" "}
                {s.pickup ? (
                  <span className="text-blue-600 font-medium">✔️ Yes</span>
                ) : (
                  <span className="text-red-600 font-medium">❌ No</span>
                )}
              </p>
              <p className="text-sm">Tracking number: {s.tracking || "-"}</p>
              <p className="text-sm">Total weight: {s.weight}</p>
              <p className="text-sm">Date shipped: {s.dateShipped}</p>
              <p className="text-sm">Ready for pickup: {s.dateReady}</p>
              <p className="text-sm">Date delivered: {s.dateDelivered}</p>
              <div className="flex justify-end">
                <button className="text-xs bg-gray-100 px-3 py-1 rounded-md hover:bg-gray-200">
                  👁 View
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex justify-between items-center mt-6 text-sm">
          <div className="flex gap-2">
            <button className="px-3 py-1 border rounded-md bg-gray-100">Previous</button>
            <button className="px-3 py-1 border rounded-md bg-blue-500 text-white">
              1
            </button>
            <button className="px-3 py-1 border rounded-md bg-gray-100">Next</button>
          </div>
          <p>
            1–3 of <span className="font-medium">3</span> items
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShipmentsPage;
